import React, { lazy } from 'react'

const PermissionNonExclusivePage = lazy(() =>
  import('./PermissionNonExclusivePage')
)

export { PermissionNonExclusivePage }
